module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf-2700.86ec40b4.svg";